import errors from "../errors";
import validate from "../validate";

const { SystemError } = errors;

interface ItemInput {
    id: string;
    name: string;
    description?: string;
    quantity?: number;
}

async function modifyCart(cartId: string, itemInput: ItemInput) {
    try {
        validate.token(sessionStorage.token)
        validate.id(cartId, "cartId");
        validate.id(itemInput.id, "itemId");
        if (itemInput.quantity !== undefined) {
            validate.number(itemInput.quantity, "quantity");
        }
        if (itemInput.name.toLowerCase().includes("camiseta")) {

            if (itemInput.description === null || itemInput.description === undefined) {
                throw new Error("Debes seleccionar una talla para  'camiseta'.");
            }
            validate.text(itemInput.description, "description");
        }
        const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/cart`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${sessionStorage.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ cartId, itemInput }),
        });

        if (res.status === 200) {
            return await res.json();
        }

        const errorBody = await res.json();
        const { error, message } = errorBody;
        const constructor = errors[error as keyof typeof errors];
        throw new constructor(message);
    } catch (error) {
        throw new SystemError(error instanceof Error ? error.message : "An unknown error occurred");
    }
}

export default modifyCart;
